
export async function clearCacheAndReloadForVerification(): Promise<void> {
  try {
    const token = String(Date.now());
    try { localStorage.setItem("verifyReloadToken", token); } catch {}

    // Unregister service workers (si existen)
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }

    // Clear Cache Storage
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }

    // Forzar recarga con query param para evitar caches intermedios
    const url = new URL(window.location.href);
    url.searchParams.set("t", token);
    window.location.replace(url.toString());
  } catch (err) {
    console.error("clearCacheAndReload error:", err);
    // fallback: recarga simple
    window.location.reload();
  }
}
